import { Icon } from '@iconify-icon/react';
import Link from 'next/link';

export interface DocArticle {
  title: string;
  description: string;
  href: string;
  readingTime?: string;
  audience?: string;
}

interface DocsCategoryCardProps {
  title: string;
  description: string;
  icon: string;
  gradient: string;
  articles: DocArticle[];
}

const DocsCategoryCard: React.FC<DocsCategoryCardProps> = ({
  title,
  description,
  icon,
  gradient,
  articles,
}) => {
  return (
    <div className="group overflow-hidden rounded-2xl border border-gray-200 bg-white transition-all hover:shadow-lg">
      {/* Header */}
      <div className={`bg-gradient-to-br ${gradient} p-6`}>
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/20 backdrop-blur-sm">
            <Icon icon={icon} className="text-2xl text-white" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-white">{title}</h3>
            <p className="text-sm text-white/80">{description}</p>
          </div>
        </div>
      </div>

      {/* Articles List */}
      <div className="divide-y divide-gray-100">
        {articles.map((article) => (
          <Link
            key={article.href}
            href={article.href}
            className="flex items-center justify-between px-6 py-4 transition-colors hover:bg-gray-50">
            <div className="flex-1">
              <h4 className="font-medium text-gray-900 group-hover:text-primary-600">
                {article.title}
              </h4>
              <p className="mt-1 line-clamp-1 text-sm text-gray-500">{article.description}</p>
            </div>
            <div className="ml-4 flex items-center gap-2 text-gray-400">
              {article.readingTime && (
                <span className="text-xs text-gray-400">{article.readingTime}</span>
              )}
              <Icon icon="tabler:chevron-right" className="text-lg" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default DocsCategoryCard;
